<header class="col-12 header-page">
    <h1 class="header__page__content__title">
        Solicitação de Boleto (Emprestimo)
    </h1>
</header>
<ng-template #showLoading>
    <spinner [show]="true"></spinner>
</ng-template>
<main class="main__content" *ngIf="ExisteBoletoPendente">
    <section class="ngTemplateNaoPossui">
        <p>
            Você já solicitou um boleto neste mês. Para solicitar um novo, é necessário cancelar ou efetuar o pagamento
            do boleto pendente.
        </p>
        <p>
            Para isso, entre em contato com nossa Central de Atendimento, presencialmente,
            pelo telefone (41) 3883-6177 ou pelo e-mail emprestimo@fcopel.org.br.
        </p>
    </section>
</main>
<main class="main__content" *ngIf="FechamentoMes">
    <section class="ngTemplateNaoPossui">
        <p>
            não é possível solicitar boletos nos últimos 3 dias úteis do mês devido ao fechamento da carteira de
            empréstimo
        </p>
    </section>
</main>
<main class="main__content" *ngIf="!ContratoAtivo">
    <section class="ngTemplateNaoPossui">
        <p>
            Não encontramos seu emprestimo Ativo, por favor verifique se o mesmo já foi depositado em sua conta ou entre
            em contato com a Fundação Copel.
        </p>
        <p>
            Para isso, entre em contato com nossa Central de Atendimento, presencialmente, pelo telefone (41) 3883-6177
            ou pelo e-mail emprestimo@fcopel.org.br.
        </p>
    </section>
</main>
<main class="main__content" *ngIf="ContratoAtivo && !ExisteParcela">
    <section class="ngTemplateNaoPossui">
        <p>
            Seu contrato ainda é recente e não houve pagamento da primeira parcela, caso queira continuar por favor
            entre
            em contato com a Fundação Copel.
        </p>
        <p>
            Para isso, entre em contato com nossa Central de Atendimento, presencialmente, pelo telefone (41) 3883-6177
            ou pelo e-mail emprestimo@fcopel.org.br.
        </p>
    </section>
</main>
<main class="main__content" *ngIf="UltimaParcela">
    <section class="ngTemplateNaoPossui">
        <p>
            Informamos que, por se tratar da última parcela do seu contrato e considerando que o pagamento já está
            previsto em seu holerite mensal, não será possível a emissão de boleto. Caso tenha alguma dúvida ou precise
            de suporte, nossa equipe está à disposição para atendê-lo.
        </p>
        <p>
            Para isso, entre em contato com nossa Central de Atendimento, presencialmente, pelo telefone (41) 3883-6177
            ou pelo e-mail emprestimo@fcopel.org.br.
        </p>
    </section>
</main>
<main class="main__content"
    *ngIf="!ExisteBoletoPendente && !FechamentoMes && ContratoAtivo  && ExisteParcela && !UltimaParcela">
    <form [formGroup]="formGroup" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2 main__page__content__form"
        (ngSubmit)="GenerateInvoice()">
        <section class="content-form">
            <div class="row">
                <div class="col-xs-4 col-xl-4 col-md-6 col-sm-12 mb-2 px-1">
                    <label class="label-form">Data de vencimento </label><label>*</label>
                    <!-- <input type="date" class="form-control input-form" formControlName="Dat_Prvpg_Blpgt"
                        (ngModelChange)="ValidateExistence()" (keydown)="disableTyping($event)"
                        (focus)="openCalendar($event)" placeholder="DD-MM-YYYY" [min]="minDate" [max]="maxDate"
                        required /> -->

                        <div class="input-group">
                            <input 
                                
                              class="form-control date" 
                              (ngModelChange)="ValidateExistence()" 
                              formControlName="Dat_Prvpg_Blpgt" 
                              placeholder="DD-MM-YYYY" 
                              name="date"  
                              ngbDatepicker  
                              #d2="ngbDatepicker"  
                              [markDisabled]="isDisabled" 
                              [displayMonths]="1" 
                              [navigation]="'none'" 
                              [minDate]="dt" 
                              [maxDate]="dtm" 
                              (focus)="openCalendar($event)" 
                               readonly
                              (click)="d2.toggle()"/>
                            <div class="input-group-append">
                              <button class="btn btn-outline-secondary" (click)="d2.toggle()" type="button">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar" viewBox="0 0 16 16">
                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>
                                  </svg>
                              </button>
                            </div>
                          </div>
                          

                    <small class="form-text text-muted danger ng-star-inserted"
                    *ngIf="formGroup.get('Dat_Prvpg_Blpgt')?.hasError('invalidDate') && invalido">
                        O campo Data inicio está inválido!
                    </small>
                </div>
                <div class="col-xs-4 col-xl-4 col-md-6 col-sm-12 mb-2 px-1">
                    <label class="label-form">Valor do boleto </label><label>*</label>
                    <input class="form-control input-form" placeholder="R$ 0,00" formControlName="Vlr_Prvst_Iblpgt"
                        maxlength="14" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask required
                        id="valorBoleto" (ngModelChange)="ChangeMaxValue()" />
                    <small class="form-text text-muted danger ng-star-inserted"
                        *ngIf="formGroup.get('Vlr_Prvst_Iblpgt')?.touched && formGroup.get('Vlr_Prvst_Iblpgt')?.invalid">
                        O campo Valor do boleto está inválido!
                    </small>
                </div>
                <div class="col-xs-4 col-xl-4 col-md-6 col-sm-12 mb-2 px-1" id="origem">
                    <label class="label-form">Origem do recurso </label><label>*</label>
                    <ng-select [items]="origemBoleto" bindLabel="nome" bindValue="id" placeholder="Origem do recurso" [searchable]="false" 
                        formControlName="Origem" required>
                    </ng-select>
                </div>
                <div class="col-xl-12" id="origem">
                    <label class="label-form">Tipo do boleto </label><label>*</label>
                    <ng-select [items]="tipoBoleto" bindLabel="nome" bindValue="id" placeholder="Tipo do boleto" [searchable]="false"
                        formControlName="Tipo" (ngModelChange)="SetValuesAntecipacao()" required>
                    </ng-select>
                    <small class="form-text text-muted danger ng-star-inserted"
                        *ngIf="formGroup.get('Tipo')?.touched && formGroup.get('Tipo')?.invalid">
                        O campo Tipo do boleto está inválido!
                    </small>
                    <small class="form-text text-muted warning ng-star-inserted">
                        &#8226; Amortização: Gerar boleto de uma parte do valor do empréstimo
                    </small>
                    <small class="form-text text-muted warning ng-star-inserted">
                        &#8226; Antecipação: Gerar boleto para quitação do empréstimo, sem considerar a parcela deste
                        mês
                    </small>
                    <small class="form-text text-muted warning ng-star-inserted">
                        &#8226; Boleto: Ao solicitar o boleto o mesmo pode demorar até 2 dias uteis para ser gerado
                    </small>
                </div>
            </div>
            <button id="btnSubmit" class="btn button-primary" type="submit" [disabled]="this.loading">
                <div class="d-flex" *ngIf="loading; else showSpan" [@fadeIn]>
                    <span>Solicitando...</span>
                </div>
                <ng-template #showSpan>
                    <span [@fadeIn]>Solicitar Boleto</span>
                </ng-template>
            </button>
        </section>
    </form>
    <section class="content__resultado__main" *ngIf="!loading; else showLoading" [@fadeIn]>
        <ng-template #loadingGrid>
            <spinner-grid />
        </ng-template>
    </section>
</main>